module.exports = "/video-roulette/img/black-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/img/black-ball.png
// module id = 2444
// module chunks = 10